(function(root, factory) {
  var api = factory(root);

  if (root) {
    root.DYOFCommerce = api;
  }

  if (typeof module === "object" && module.exports) {
    module.exports = api;
  }
})(typeof globalThis !== "undefined" ? globalThis : this, function(root) {
  "use strict";

  // Translations (assets/dyof-i18n.js, non-English stores only). The English
  // stays here and is used as is when no language pack is loaded.
  function dyofInterpolate(text, params) {
    return params ? String(text).replace(/\{([A-Za-z0-9_]+)\}/g, function(match, name) {
      return Object.prototype.hasOwnProperty.call(params, name) && params[name] != null ? String(params[name]) : match;
    }) : text;
  }
  function dyofT(key, english, params) {
    var i18n = root.DYOFI18n;
    return i18n ? i18n.t(key, english, params) : dyofInterpolate(english, params);
  }
  function dyofPlural(key, count, english, params) {
    var i18n = root.DYOFI18n;
    var values = Object.assign({ count: count }, params || {});
    return i18n ? i18n.plural(key, count, english, params) : dyofInterpolate(Number(count) === 1 ? english.one : english.other, values);
  }

  var LEGACY_LAYOUT_OPTIONS = {
    daily: "Day to View",
    weekly: "Week to View",
    "two-weeks": "Two Weeks to View",
    "vertical-weekly": "Vertical Week to View",
    monthly: "Month to View"
  };
  var LEGACY_LAYOUT_ORDER = [
    "daily",
    "weekly",
    "vertical-weekly",
    "two-weeks",
    "monthly"
  ];
  var DYOF_CLIPBOOK_BUNDLE_TYPE = "dyof-module-clipbook-refill-v1";
  var DYOF_LIFESTYLE_JOURNAL_HANDLES = new Set([
    "baby-journal-refill-a5",
    "wedding-journal-refill-a5",
    "gardening-journal-refill-a5",
    "life-essentials-refill-a5",
    "cookbook-journal-refill-a5",
    "pet-journal-refill-a5"
  ]);
  var DYOF_PLANNER_JOURNAL_HANDLES = new Set([
    "dyof-planner-baby-journal-a5",
    "dyof-planner-wedding-journal-a5",
    "dyof-planner-gardening-journal-a5",
    "dyof-planner-life-essentials-a5",
    "dyof-planner-cookbook-journal-a5",
    "dyof-planner-pet-journal-a5"
  ]);
  var DYOF_PLANNER_COVER_GBP_CENTS = 1900;
  // An organiser page's DESIGN YOUR OWN REFILL button sells its organiser with
  // one module refill at 30% off the refill (bundle-filo contract
  // dyof-organiser-refill-v1). Organiser rules mirror isDyorParentProduct;
  // the module's own Custom Clipbook is never an organiser here.
  var DYOF_ORGANISER_BUNDLE_TYPE = "dyof-organiser-refill-v1";
  var DYOF_ORGANISER_REFILL_HANDLES = new Set([
    "design-your-own-refill",
    "design-your-own-refill-1",
    "dyof-new-colourful-refill",
    "dyof-everyday-refill"
  ]);
  var DYOF_ORGANISER_PRODUCT_TYPES = new Set([
    "organiser",
    "organisers",
    "organizer",
    "organizers",
    "clipbook",
    "clipbooks"
  ]);
  var DYOF_ORGANISER_PRODUCT_HANDLES = new Set(["clipbook-creative-kit-filofax"]);
  var DYOF_ORGANISER_SIZES = ["personal", "a5", "a4"];
  var DYOF_ORDER_REFERENCE_PATTERN = /^dyoforder_[a-f0-9]{32}$/;
  var DYOF_MEDIA_REFERENCE_PATTERN = /^dyofmedia_[a-f0-9]{32}$/;
  var DYOF_PUBLIC_LABEL_MAX_LENGTH = 80;
  var CONTROL_CHARACTER_PATTERN = /[\u0000-\u001f\u007f]/;
  var DYOF_PUBLIC_LABELS = [
    ["design", "Design"],
    ["size", "Size"],
    ["refill", "Refill"],
    ["layout", "Layout"]
  ];
  var DYOF_CART_MEDIA_ROLES = new Set(["cover", "refill"]);
  // The old cover builder's White Clipbook (refill-js.liquid colorMap), which
  // the printer's front sheet shows as the Interior Colour. New-module
  // Clipbooks have no inside-colour choice: always White. Planners and
  // refill-only orders never had an Interior Colour.
  var DYOF_CLIPBOOK_INTERIOR_COLOURS = { a5: "White 23610", personal: "White 23634" };

  function normalize(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");
  }

  function optionNames(catalog) {
    return (catalog && Array.isArray(catalog.options) ? catalog.options : []).map(function(option) {
      return normalize(option && typeof option === "object" ? option.name : option);
    });
  }

  function optionIndex(catalog, name, fallbackIndex) {
    var index = optionNames(catalog).indexOf(normalize(name));
    return index === -1 ? fallbackIndex : index;
  }

  function variantOption(variant, index) {
    if (variant && Array.isArray(variant.options)) {
      return normalize(variant.options[index]);
    }
    return normalize(variant && variant["option" + (index + 1)]);
  }

  function legacyLayoutOption(layout) {
    return LEGACY_LAYOUT_OPTIONS[layout] || null;
  }

  function legacySelectionKey(selection) {
    var layout = legacyLayoutOption(selection && selection.layout);
    if (!selection || selection.engine !== "legacy" || !layout) {
      return null;
    }

    return [
      normalize(selection.size),
      normalize(selection.style),
      normalize(layout)
    ].join("|");
  }

  function isLegacyServerSupported(selection) {
    return !(
      selection
      && selection.size === "personal"
      && selection.layout === "vertical-weekly"
    );
  }

  function variantKey(catalog, variant) {
    return [
      variantOption(variant, optionIndex(catalog, "size", 0)),
      variantOption(variant, optionIndex(catalog, "style", 1)),
      variantOption(variant, optionIndex(catalog, "layout", 2))
    ].join("|");
  }

  function result(status, key, variant, message) {
    return {
      status: status,
      key: key,
      variant: variant || null,
      message: message || null
    };
  }

  function resolveLegacyVariant(catalog, selection) {
    var key = legacySelectionKey(selection);
    var variants;
    var matches;

    if (!key) {
      return result("not-applicable", null, null, null);
    }

    if (!isLegacyServerSupported(selection)) {
      return result(
        "unsupported",
        key,
        null,
        dyofT("commerce.variant.personal_vertical", "Personal Vertical Week to View is not available in the retained server template library.")
      );
    }

    variants = catalog && Array.isArray(catalog.variants) ? catalog.variants : [];
    matches = variants.filter(function(variant) {
      return variantKey(catalog, variant) === key;
    });

    if (matches.length === 0) {
      return result(
        "missing",
        key,
        null,
        dyofT("commerce.variant.missing", "This size, style and layout combination is not available to purchase.")
      );
    }

    if (matches.length > 1) {
      return result(
        "ambiguous",
        key,
        null,
        dyofT("commerce.variant.ambiguous", "This selection matches more than one product variant. Please refresh and try again.")
      );
    }

    if (!Number.isFinite(Number(matches[0].id)) || Number(matches[0].id) <= 0) {
      return result(
        "invalid",
        key,
        null,
        dyofT("commerce.variant.invalid_selection", "The selected product variant is invalid. Please refresh and try again.")
      );
    }

    if (matches[0].available === false) {
      return result(
        "unavailable",
        key,
        matches[0],
        dyofT("commerce.variant.unavailable", "This size, style and layout combination is currently unavailable.")
      );
    }

    return result("ready", key, matches[0], null);
  }

  function firstAvailableLegacyLayout(catalog, selection, layoutOrder) {
    var order = Array.isArray(layoutOrder) && layoutOrder.length
      ? layoutOrder
      : LEGACY_LAYOUT_ORDER;
    var index;
    var candidate;

    for (index = 0; index < order.length; index += 1) {
      candidate = Object.assign({}, selection, { layout: order[index] });
      if (resolveLegacyVariant(catalog, candidate).status === "ready") {
        return order[index];
      }
    }

    return null;
  }

  function displayPrice(variant, currency) {
    if (!variant) {
      return null;
    }
    // A catalogue priceLabel already names its currency. Do not assume GBP
    // for a supplied label when the caller has not provided a currency.
    if (root.DYOFI18n && (currency || variant.currency) && Number.isFinite(Number(variant.price))) {
      return root.DYOFI18n.money(Number(variant.price), currency || variant.currency);
    }
    if (variant.priceLabel) {
      return String(variant.priceLabel);
    }
    if (Number.isFinite(Number(variant.price))) {
      if (root.DYOFI18n) {
        return root.DYOFI18n.money(Number(variant.price), currency || variant.currency || "GBP");
      }
      return "£" + (Number(variant.price) / 100).toFixed(2).replace(/\.00$/, "");
    }
    return null;
  }

  function isPurchasableVariant(variant) {
    return Boolean(
      variant
      && Number.isFinite(Number(variant.id))
      && Number(variant.id) > 0
      && variant.available !== false
      && Number.isFinite(Number(variant.price))
      && Number(variant.price) > 0
    );
  }

  function findVariantById(catalog, variantId) {
    var id = Number(variantId);
    var matches;
    if (!Number.isFinite(id) || id <= 0) {
      return result("invalid", String(variantId || ""), null, dyofT("commerce.variant.invalid", "The product variant is invalid."));
    }
    matches = (catalog && Array.isArray(catalog.variants) ? catalog.variants : []).filter(function(variant) {
      return Number(variant && variant.id) === id;
    });
    if (matches.length === 0) {
      return result("missing", String(id), null, dyofT("commerce.variant.not_in_catalogue", "The product variant is not in the live catalogue."));
    }
    if (matches.length > 1) {
      return result("ambiguous", String(id), null, dyofT("commerce.variant.duplicated", "The product variant is duplicated in the live catalogue."));
    }
    if (!isPurchasableVariant(matches[0])) {
      return result(
        matches[0] && matches[0].available === false ? "unavailable" : "invalid",
        String(id),
        matches[0],
        dyofT("commerce.variant.not_purchasable", "The product variant is not available to purchase.")
      );
    }
    return result("ready", String(id), matches[0], null);
  }

  function displayMoney(amount, currency) {
    var cents = Number(amount);
    var code = String(currency || "GBP").toUpperCase();
    var fractionDigits;
    if (!Number.isFinite(cents)) {
      return null;
    }
    if (root.DYOFI18n) {
      return root.DYOFI18n.money(cents, code);
    }
    fractionDigits = Math.round(cents) % 100 === 0 ? 0 : 2;
    try {
      return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: code,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (error) {
      return (code === "GBP" ? "£" : code + " ")
        + (cents / 100).toFixed(fractionDigits);
    }
  }

  function resolveOfferCandidates(candidates, exact, currency) {
    var seen = new Set();
    var valid = (Array.isArray(candidates) ? candidates : []).filter(function(candidate) {
      var items = candidate && Array.isArray(candidate.items) ? candidate.items : [];
      var key;
      if (!items.length || !items.every(function(item) {
        return item && isPurchasableVariant(item.variant);
      })) {
        return false;
      }
      key = items.map(function(item) {
        return String(item.role || "item") + ":" + String(item.variant.id);
      }).join("|");
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      candidate.offerKey = candidate.offerKey || key;
      candidate.amount = items.reduce(function(total, item) {
        return total + purchaseItemPriceCents(item, items, currency);
      }, 0);
      // A separate catalogue quote is presentation only. Keep promotional
      // sorting, selected items and cart pricing unchanged.
      candidate.previewAmount = items.reduce(function(total, item) {
        return total + Number(item.variant.price);
      }, 0);
      return true;
    }).sort(function(left, right) {
      return left.amount - right.amount;
    });
    var selected;

    if (!valid.length) {
      return {
        status: "unavailable",
        offerKey: null,
        price: { mode: "none", amount: null, currency: currency || "GBP" },
        items: [],
        candidateCount: 0,
        message: dyofT("commerce.offer.unavailable", "No compatible product combination is currently available.")
      };
    }

    if (exact && valid.length !== 1) {
      return {
        status: "ambiguous",
        offerKey: null,
        price: { mode: "none", amount: null, currency: currency || "GBP" },
        items: [],
        candidateCount: valid.length,
        message: dyofT("commerce.offer.ambiguous", "This selection does not resolve to one purchasable product combination.")
      };
    }

    selected = valid[0];
    return {
      status: exact ? "ready" : "partial",
      offerKey: selected.offerKey,
      price: {
        mode: exact ? "exact" : "from",
        amount: selected.amount,
        currency: currency || "GBP"
      },
      previewPrice: {
        mode: exact ? "exact" : "from",
        amount: exact ? selected.previewAmount : Math.min.apply(null, valid.map(function(candidate) {
          return candidate.previewAmount;
        })),
        currency: currency || "GBP"
      },
      items: exact ? selected.items.map(function(item) {
        var copy = {
          role: item.role || "item",
          variant: item.variant,
          quantity: Number(item.quantity) > 0 ? Number(item.quantity) : 1
        };
        // An organiser beside a refill outside the 30% offer stays full price.
        if (typeof item.bundled === "boolean") {
          copy.bundled = item.bundled;
        }
        return copy;
      }) : [],
      candidateCount: valid.length,
      message: null
    };
  }

  function requiredString(value, fieldName) {
    var text = typeof value === "string" ? value.trim() : "";
    if (!text) {
      throw new TypeError(dyofT("commerce.cart.required_field", "{field} is required.", { field: fieldName }));
    }
    return text;
  }

  function requiredPublicLabel(value, fieldName) {
    var text = requiredString(value, fieldName);
    if (text.length > DYOF_PUBLIC_LABEL_MAX_LENGTH || CONTROL_CHARACTER_PATTERN.test(text)) {
      throw new TypeError(dyofT("commerce.cart.public_label_length", "{field} must be a single-line value of 80 characters or fewer.", { field: fieldName }));
    }
    return text;
  }

  function normalizedPurchaseItem(item, index) {
    var variant = item && item.variant;
    var role = requiredString(item && item.role, "purchaseItems[" + index + "].role").toLowerCase();
    var quantity = Number(item && item.quantity);
    var variantId;
    var priceCents;

    if (!isPurchasableVariant(variant)) {
      throw new TypeError(dyofT("commerce.cart.item_variant", "purchaseItems[{index}].variant must be a resolved purchasable variant.", { index: index }));
    }
    variantId = Number(variant.id);
    priceCents = Number(variant.price);
    if (!Number.isSafeInteger(variantId) || !Number.isSafeInteger(priceCents)) {
      throw new TypeError(dyofT("commerce.cart.item_integers", "purchaseItems[{index}].variant must use integer Shopify IDs and prices in cents.", { index: index }));
    }
    if (!Number.isSafeInteger(quantity) || quantity <= 0) {
      throw new TypeError(dyofT("commerce.cart.item_quantity", "purchaseItems[{index}].quantity must be a positive integer.", { index: index }));
    }

    return {
      role: role,
      variant: variant,
      variantId: variantId,
      priceCents: priceCents,
      quantity: quantity,
      title: requiredString(
        item && item.title || variant && variant.title,
        "purchaseItems[" + index + "].title"
      )
    };
  }

  function publicLabelProperties(publicLabels, coverOnly) {
    var labels = publicLabels && typeof publicLabels === "object" ? publicLabels : {};
    var properties = {};

    DYOF_PUBLIC_LABELS.forEach(function(entry) {
      // A Clipbook cover on its own has no Refill or Layout to show.
      if (coverOnly && (entry[0] === "refill" || entry[0] === "layout")) {
        return;
      }
      properties[entry[1]] = requiredPublicLabel(labels[entry[0]], "publicLabels." + entry[0]);
    });

    return properties;
  }

  // Cover only is honoured for exactly one Clipbook item and nothing else.
  function isCoverOnlyOrder(input) {
    var items = Array.isArray(input.purchaseItems) ? input.purchaseItems : [];
    var role = items.length === 1 && items[0] ? items[0].role : null;
    return input.coverOnly === true
      && typeof role === "string"
      && role.trim().toLowerCase() === "clipbook";
  }

  function clipbookInteriorColour(size) {
    var key = normalize(size);
    return Object.prototype.hasOwnProperty.call(DYOF_CLIPBOOK_INTERIOR_COLOURS, key)
      ? DYOF_CLIPBOOK_INTERIOR_COLOURS[key]
      : "White";
  }

  function cartMediaRole(cartMedia, itemRole) {
    var marker;
    if (!cartMedia || typeof cartMedia !== "object" || !Object.prototype.hasOwnProperty.call(cartMedia, itemRole)) {
      return null;
    }
    marker = normalize(cartMedia[itemRole]);
    if (!DYOF_CART_MEDIA_ROLES.has(marker)) {
      throw new TypeError(dyofT("commerce.cart.media_role", "cartMedia.{role} must be either cover or refill.", { role: itemRole }));
    }
    return marker;
  }

  function isClipbookRefillBundle(items) {
    return items.length === 2
      && items.filter(function(item) { return item.role === "clipbook"; }).length === 1
      && items.filter(function(item) { return item.role === "refill"; }).length === 1;
  }

  function isOrganiserProduct(product) {
    var handle = normalize(product && product.handle);
    // Shopify's /products/<handle>.js names the product type "type".
    var type = normalize(product && (product.type != null ? product.type : product.product_type));
    return handle !== "custom-clipbook"
      && (DYOF_ORGANISER_PRODUCT_TYPES.has(type) || DYOF_ORGANISER_PRODUCT_HANDLES.has(handle));
  }

  function isOrganiserRefillVariant(variant) {
    return DYOF_ORGANISER_REFILL_HANDLES.has(normalize(variant && variant.productHandle));
  }

  // The organiser the cart names (note = product handle, attributes.variant)
  // when the page was opened with ?size=&source_product_id=. Null unless it is
  // an available variant of exactly that organiser product. The price is for
  // display only; Shopify charges from its own line costs.
  function organiserContext(cart, product, entry) {
    var attributes = cart && cart.attributes && typeof cart.attributes === "object" ? cart.attributes : {};
    var variantId = String(attributes.variant == null ? "" : attributes.variant).trim();
    var variants = product && Array.isArray(product.variants) ? product.variants : [];
    var title = String(product && product.title || "").trim();
    var variant;
    var priceCents;
    if (
      !entry
      || !/^\d{1,20}$/.test(String(entry.productId || ""))
      || DYOF_ORGANISER_SIZES.indexOf(entry.size) === -1
      || !/^\d{1,20}$/.test(variantId)
      || !normalize(cart && cart.note)
      || !product
      || String(product.id) !== String(entry.productId)
      || !isOrganiserProduct(product)
      || !title
    ) {
      return null;
    }
    variant = variants.filter(function(candidate) {
      return String(candidate && candidate.id) === variantId;
    })[0];
    priceCents = Number(variant && variant.price);
    if (!variant || variant.available !== true || !Number.isSafeInteger(priceCents) || priceCents <= 0
      || !Number.isSafeInteger(Number(variantId))) {
      return null;
    }
    return {
      variantId: Number(variantId),
      productId: Number(product.id),
      handle: normalize(product.handle),
      title: title,
      // The colour/option the customer picked, e.g. "Black / No Diary".
      variantTitle: String(variant.title || "").trim() === "Default Title" ? "" : String(variant.title || "").trim(),
      priceCents: priceCents,
      size: entry.size
    };
  }

  // An organiser offered beside an ineligible refill (bundled: false) is full price.
  function isOrganiserRefillBundle(items) {
    return items.length === 2
      && items.filter(function(item) { return item.role === "organiser" && item.bundled !== false; }).length === 1
      && items.filter(function(item) { return item.role === "refill"; }).length === 1;
  }

  // Mirrors the Cart Transform and Discount Function's journal promotions for
  // display only. Catalogue prices stay intact; Shopify calculates the charge
  // from its own costs and never trusts these client-side display amounts.
  function purchaseItemPriceCents(item, purchaseItems, currency) {
    var items = Array.isArray(purchaseItems) ? purchaseItems : [];
    var price = Number(item && item.variant && item.variant.price) || 0;
    var clipbook;
    var quantity;
    // The six single-line Planners keep their stated £19 cover full price.
    // Currency must be known GBP; a future cover-price change needs a matched
    // Function/helper update. Separate Journal prices do not set this amount.
    if (item && item.role === "planner"
      && items.length === 1
      && String(currency || "").trim().toUpperCase() === "GBP"
      && DYOF_PLANNER_JOURNAL_HANDLES.has(normalize(item.variant && item.variant.productHandle))
      && isPurchasableVariant(item.variant)
      && Number.isSafeInteger(price) && price > DYOF_PLANNER_COVER_GBP_CENTS) {
      quantity = Number(item.quantity == null ? 1 : item.quantity);
      if (Number.isSafeInteger(quantity) && quantity > 0) {
        return DYOF_PLANNER_COVER_GBP_CENTS
          + Math.round((price - DYOF_PLANNER_COVER_GBP_CENTS) * 0.85);
      }
    }
    // Organiser + refill: the refill is 30% off, the organiser full price.
    if (item && item.role === "refill" && isOrganiserRefillBundle(items)
      && isOrganiserRefillVariant(item.variant)
      && items.every(function(candidate) {
        return isPurchasableVariant(candidate.variant)
          && Number(candidate.quantity == null ? 1 : candidate.quantity) === Number(item.quantity == null ? 1 : item.quantity);
      })) {
      return Math.round(price * 0.7);
    }
    if (!item || item.role !== "refill" || !isClipbookRefillBundle(items)
      || !DYOF_LIFESTYLE_JOURNAL_HANDLES.has(normalize(item.variant && item.variant.productHandle))) {
      return price;
    }
    clipbook = items.filter(function(candidate) { return candidate.role === "clipbook"; })[0];
    quantity = Number(item.quantity == null ? 1 : item.quantity);
    if (normalize(clipbook.variant && clipbook.variant.productHandle) !== "custom-clipbook"
      || !items.every(function(candidate) { return isPurchasableVariant(candidate.variant); })
      || !Number.isSafeInteger(quantity) || quantity <= 0
      || Number(clipbook.quantity == null ? 1 : clipbook.quantity) !== quantity) {
      return price;
    }
    return Math.round(price * 0.85);
  }

  // options.organiser = { variantId, priceCents, title, size } is bought with
  // a single refill. A Design Your Own refill of the organiser's size joins it
  // at 30% off; any other refill is sold beside a plain, full-price organiser
  // line. Clipbook and Planner purchases ignore it.
  function organiserBundle(input, items) {
    var organiser = input.organiser;
    var variantId;
    var priceCents;
    if (!organiser || typeof organiser !== "object" || items.length !== 1 || items[0].role !== "refill") {
      return null;
    }
    variantId = Number(organiser.variantId);
    priceCents = Number(organiser.priceCents);
    if (!Number.isSafeInteger(variantId) || variantId <= 0 || !Number.isSafeInteger(priceCents) || priceCents < 0) {
      throw new TypeError(dyofT("commerce.cart.organiser_invalid", "The organiser for this refill is invalid. Please go back to the organiser and try again."));
    }
    return {
      variantId: variantId,
      priceCents: priceCents,
      title: requiredString(organiser.title, "organiser.title"),
      bundled: isOrganiserRefillVariant(items[0].variant)
        && (organiser.size == null || normalize(organiser.size) === normalize(input.size))
    };
  }

  function buildCartItems(options) {
    var input = options && typeof options === "object" ? options : {};
    var orderReference = requiredString(input.orderReference, "orderReference");
    var productionRole = requiredString(input.productionRole, "productionRole").toLowerCase();
    var publicProperties = publicLabelProperties(input.publicLabels, isCoverOnlyOrder(input));
    var items = (Array.isArray(input.purchaseItems) ? input.purchaseItems : []).map(normalizedPurchaseItem);
    var mediaRoles = {};
    var mediaReference = input.mediaReference == null ? "" : String(input.mediaReference).trim();
    var isBundle;
    var productionItems;
    var parentVariantId;
    var interior;
    var organiser;
    var lines;

    if (!DYOF_ORDER_REFERENCE_PATTERN.test(orderReference)) {
      throw new TypeError(dyofT("commerce.cart.order_reference", "orderReference must be a valid DYOF production reference."));
    }
    if (!items.length) {
      throw new TypeError(dyofT("commerce.cart.items_required", "purchaseItems must contain at least one resolved item."));
    }
    items.forEach(function(item) {
      var marker = cartMediaRole(input.cartMedia, item.role);
      if (marker) { mediaRoles[item.role] = marker; }
    });
    if (input.mediaReference != null && !DYOF_MEDIA_REFERENCE_PATTERN.test(mediaReference)) {
      throw new TypeError(dyofT("commerce.cart.media_reference", "mediaReference must be a valid private DYOF cart-media reference."));
    }

    isBundle = isClipbookRefillBundle(items);
    interior = items.some(function(item) { return item.role === "clipbook"; })
      ? clipbookInteriorColour(input.size)
      : "";
    if (items.length > 1 && !isBundle) {
      throw new TypeError(dyofT("commerce.cart.bundle_pair", "Only a Clipbook and refill pair can be submitted as a DYOF bundle."));
    }

    productionItems = items.filter(function(item) { return item.role === productionRole; });
    if (productionItems.length !== 1) {
      throw new TypeError(dyofT("commerce.cart.production_role", "productionRole must identify exactly one purchase item."));
    }

    if (isBundle) {
      items.sort(function(left, right) {
        if (left.role === right.role) {
          return 0;
        }
        return left.role === "clipbook" ? -1 : 1;
      });
      if (items[0].quantity !== items[1].quantity) {
        throw new TypeError(dyofT("commerce.cart.bundle_quantities", "Clipbook and refill bundle quantities must match."));
      }
      parentVariantId = String(items[0].variantId);
    }
    organiser = organiserBundle(input, items);

    lines = items.map(function(item) {
      var properties = Object.assign({
        "_DYOF Bundle ID": orderReference,
        "_DYOF Bundle Role": item.role,
        "_DYOF Variant SKU": item.variant.sku ? String(item.variant.sku) : ""
      }, publicProperties);
      var mediaRole = mediaRoles[item.role] || null;

      if (interior) {
        properties["_Interior Colour"] = interior;
      }
      if (item.role === productionRole) {
        properties["_DYOF Order Reference"] = orderReference;
        if (mediaReference) {
          // A separate body-only media capability keeps the fulfillment order
          // reference unable to read customer artwork.
          properties["_DYOF Media Reference"] = mediaReference;
        }
      }
      if (mediaRole) {
        // This marker contains no URL or storage capability.
        properties["_DYOF Cart Media Role"] = mediaRole;
      }
      if (isBundle) {
        properties._bundleId = orderReference;
        properties._bundle_type = DYOF_CLIPBOOK_BUNDLE_TYPE;
        properties._parent = parentVariantId;
        // `dyof` is intentionally distinct from the normal-PDP `dyor` role,
        // whose existing Cart Transform contract applies a 30% promotion.
        properties._role = item.role === "clipbook" ? "main" : "dyof";
        // Display metadata uses the resolved catalogue price and matching
        // journal promotion; Shopify remains the price authority.
        properties._orig_cents = String(item.priceCents);
        properties._now_cents = String(purchaseItemPriceCents(item, items, input.currency));
        properties._title = item.title;
      } else if (organiser && organiser.bundled) {
        // The refill keeps every standalone DYOF property, so the order line
        // still carries its production reference, and joins the organiser.
        properties._bundleId = orderReference;
        properties._bundle_type = DYOF_ORGANISER_BUNDLE_TYPE;
        properties._parent = String(organiser.variantId);
        properties._role = "dyof";
        properties["Bundle with"] = organiser.title;
        properties["Special Price"] = "Initial refill with the purchase of an organiser.";
        // Display only: bundle-filo charges 30% off from Shopify's line costs.
        properties._orig_cents = String(item.priceCents);
        properties._now_cents = String(Math.round(item.priceCents * 0.7));
        properties._title = item.title;
      } else if (purchaseItemPriceCents(item, items, input.currency) < item.priceCents) {
        properties._orig_cents = String(item.priceCents);
        properties._now_cents = String(purchaseItemPriceCents(item, items, input.currency));
      }

      return {
        id: item.variantId,
        quantity: item.quantity,
        properties: properties
      };
    });

    if (organiser) {
      // The organiser line comes first and carries no DYOF property; outside
      // the bundle it is an ordinary full-price organiser.
      lines.unshift({
        id: organiser.variantId,
        quantity: items[0].quantity,
        properties: organiser.bundled ? {
          _bundleId: orderReference,
          _bundle_type: DYOF_ORGANISER_BUNDLE_TYPE,
          _parent: String(organiser.variantId),
          _role: "main",
          "Bundle With": "Design Your Own Refill",
          _orig_cents: String(organiser.priceCents),
          _now_cents: String(organiser.priceCents),
          _title: organiser.title
        } : {}
      });
    }
    return lines;
  }

  return {
    legacyLayoutOptions: LEGACY_LAYOUT_OPTIONS,
    legacyLayoutOrder: LEGACY_LAYOUT_ORDER.slice(),
    legacyLayoutOption: legacyLayoutOption,
    legacySelectionKey: legacySelectionKey,
    isLegacyServerSupported: isLegacyServerSupported,
    resolveLegacyVariant: resolveLegacyVariant,
    firstAvailableLegacyLayout: firstAvailableLegacyLayout,
    displayPrice: displayPrice,
    displayMoney: displayMoney,
    purchaseItemPriceCents: purchaseItemPriceCents,
    isPurchasableVariant: isPurchasableVariant,
    findVariantById: findVariantById,
    resolveOfferCandidates: resolveOfferCandidates,
    dyofClipbookBundleType: DYOF_CLIPBOOK_BUNDLE_TYPE,
    dyofOrganiserBundleType: DYOF_ORGANISER_BUNDLE_TYPE,
    isOrganiserProduct: isOrganiserProduct,
    isOrganiserRefillVariant: isOrganiserRefillVariant,
    organiserContext: organiserContext,
    buildCartItems: buildCartItems
  };
});
